import { render, staticRenderFns } from "./GroupAssignmentModal.vue?vue&type=template&id=30e9fec8&scoped=true"
import script from "./GroupAssignmentModal.vue?vue&type=script&lang=js"
export * from "./GroupAssignmentModal.vue?vue&type=script&lang=js"
import style0 from "./GroupAssignmentModal.vue?vue&type=style&index=0&id=30e9fec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e9fec8",
  null
  
)

export default component.exports